<template>
  <div>
    <input :type="isPassword ? 'password' : 'text'" v-model="currentValue"
      class="w-full border border-grey rounded-lg
            py-2 px-2" :placeholder="placeholder">
  </div>
</template>

<script>
export default {
  name: 'TextInput',
  props: ['placeholder', 'isPassword'],
  data () {
    return {
      currentValue: ''
    }
  },
  methods: {
    getValue () {
      return this.currentValue
    },
    isValid () {
      return this.currentValue !== ''
    },
    clear () {
      this.currentValue = ''
    }
  }
}
</script>
